import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the history movement view.
 * @extends JetView
 */
export default class tableHistoryMovementView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        /**
         * Function to mark new movements with specific colors.
         * @param {string} value - The movement type.
         * @returns {string} The CSS class for the movement type.
         */
        function mark_new(value) {
            if (value == 'Entrada') {
                return 'lightgreen'; // Color for 'Entrada'
            } else {
                if (value == 'Salida') {
                    return 'highlight'; // Color for 'Salida'
                } else {
                    return ''; // Default color
                }
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'Id',
                                    header: 'ID', // Column header
                                    width: 100,
                                    sort: 'int', // Sort by integer
                                },
                                {
                                    id: 'Movement',
                                    header: _('Movimiento'), // Localized column header
                                    options: [
                                        { id: '0', value: _('Entrada') }, // Movement options
                                        { id: '1', value: _('Salida') },
                                        { id: '2', value: _('Cancelación') },
                                    ],
                                    width: 200,
                                    sort: 'int',
                                    cssFormat: mark_new, // Apply custom CSS formatting
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'), // Localized column header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('ID Externo'), // Localized column header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'CreatedLocalDate',
                                    header: _('Fecha de creación'), // Localized column header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text',
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Localized column header
                                    width: 100,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'BalanceDeposit',
                                    header: _('Saldo recargas'), // Localized column header
                                    width: 100,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'BalanceWithdrawal',
                                    header: _('Saldo retiros'), // Localized column header
                                    width: 100,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Hide loading overlay after data load
                                    this.hideOverlay();
                                },
                            },
                            ready: function () {
                                // Show no data overlay if no records are found
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceMovement?UserId=' + profile.UserId + '&'; // API URL for fetching balance movements
        var filter = ''; // Filter string for API requests
        const _ = this.app.getService('locale')._; // Localization service
        var flag = false; // Flag for export operation
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Event listener for filtering data
        this.on(this.app, 'historyMovement:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });

        // Event listener for export filtering
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set flag for export operation
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            grid.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            grid.attachEvent('onAfterLoad', function () {
                if (flag) {
                    var size = grid.getPager().config.size; // Get pager size
                    var page = grid.getPage(); // Get current page
                    var first = size * page; // Calculate first index for current page
                    var last = first + size - 1; // Calculate last index for current page
                    if ($$('Export').getValue() == '1') {
                        for (var j = 0; j < grid.config.columns.length; j++) {
                            if (grid.config.columns[j].exportType) {
                                delete grid.config.columns[j].format; // Remove format for export
                            }
                        }
                        this.app.callEvent('export:data', [
                            {
                                NameReport:
                                    _('Historial de movimientos') +
                                    ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                    ' - ' +
                                    new Date().toLocaleString(), // Report name
                                TypeReport: 'Excel', // Report type
                            },
                        ]);
                        webix.toExcel(grid, {
                            filter: function (obj) {
                                return (
                                    grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter for exporting data
                                );
                            },
                            filename:
                                'Virtualsoft - ' +
                                new Date()
                                    .toLocaleString('en-GB', { hour12: true })
                                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                    .replace(/[\/:]/g, '_')
                                    .toUpperCase() +
                                ' - ' +
                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                _('Historial de movimientos'), // Filename for export
                            ignore: { detailTittle: true }, // Ignore detail title in export
                            footer: false, // Do not include footer in export
                        });
                    } else {
                        if ($$('Export').getValue() == '2') {
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Historial de movimientos') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'PDF', // Report type
                                },
                            ]);
                            webix.toPDF(grid, {
                                filter: function (obj) {
                                    return (
                                        grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter for exporting data
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Historial de movimientos'), // Filename for export
                                autowidth: true, // Auto width for PDF
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        }
                    }
                    flag = false; // Reset flag after export
                    $$('Export').setValue(''); // Reset export selection
                }
            });
        });
    }
}

// FILE DOCUMENTED
